$(document).ready(function(){
  var sideWidth = $('.side_menu_container').outerWidth();
  $('.wrapper').css('padding-left',sideWidth+'px');
  var windowHeight = $(window).height();
  var titleHeight = $('.mv_logo').height();
  var windowWidth = $('body').width();
  var titleWidth = $('.mv_logo').width();
  var titlePosX = $('.mv_logo').offset().left;
  var titlePosY = $('.mv_logo').offset().top;
  var scroll = $(window).scrollTop();
  if (scroll == 0) {
    $('.mv_logo').css('transform','translate('+(((windowWidth-titleWidth)/2-titlePosX))+'px,'+(((windowHeight-titleHeight)/2-titlePosY))+'px)');
    setTimeout(function(){
      $('.mv_logo').css('transition','200ms');
      $('.mv_logo').addClass('active');
    },20);
    setTimeout(function(){
      $('.mv_logo').css('transition','600ms');
      $('.mv_logo').addClass('active2');
      $('.overlay_white').fadeOut(1000);
    },1600);
    setTimeout(function(){
      $('.mv_title').addClass('active');
      $('.mv_center').css('z-index','3');
    },2200);
  }else{
    $('.mv_logo').addClass('active2');
    $('.mv_logo').addClass('active3');
    $('.overlay_white').hide();
    $('.mv_title').addClass('active');
    $('.mv_center').css('z-index','3');
  }
});

$(window).on('load resize',function(){
  var sideWidth = $('.side_menu_container').outerWidth();
  $('.wrapper').css('padding-left',sideWidth+'px');
  setTimeout(function(){
    $('svg').each(function (){
      var containerWidth = $(this).parents('.svg').width();
      var svgWidth = $(this).width();
      var svgPosW = (containerWidth - svgWidth) / 2;
      var containerHeight = $(this).parents('.svg').find('.full_img').height();
      var svgHeight = $(this).height();
      var svgPosH = (containerHeight - svgHeight) / 2;
      if ($(this).hasClass('clip_svg')) {
        $(this).find('clipPath').css('transform','translate('+svgPosW+'px,'+svgPosH+'px)');
      }else{
        $(this).css('transform','translate('+svgPosW+'px,'+svgPosH+'px)');
      }
    });
  },10);

});



$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.25;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }else{
          This.removeClass('active');
        }
    });

    $('.contents_section').each(function(){
      var secPos = $(this).offset().top;
      var num = $(this).data('n');
      var firstPos = $('#mousepad').offset().top;
      var bottomPos = $('#bottom').offset().top;
      if (scroll < firstPos - (windowHeight / 2.5)) {
        $('.side_menu li').removeClass('active');
      }
      if (scroll > secPos - (windowHeight / 2.5)) {
        $('.side_menu li').removeClass('active');
        $('.side_menu li:nth-child('+num+')').addClass('active');
      }
      if (scroll > bottomPos - (windowHeight / 2.5)) {
        $('.side_menu li').removeClass('active');
      }
    });
  });


  var mainSwiper = new Swiper('#slider', {
    // パラメーター
    loop: true,
    slidesPerView: 4,
    speed:4000,
    allowTouchMove: false,
    autoplay: {delay: 0},
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween:20
      }
    }
  });
  $(window).resize(function(){
      mainSwiper.autoplay.paused = false;
      mainSwiper.autoplay.start();
  });

  // modal
    $('.swiper-slide').click(function(){
      var modalImg = $(this).html();
      $('body').append('<div class="modal_bg flex flex_middle flex_center"><div class="modal_img">'+modalImg+'</div></div>');
      $('body').css('overflow','hidden');

      $('.modal_bg').click(function(){
        $(this).remove();
        $('body').css('overflow','auto');
      });
    });


    // menu btn
    $('.side_menu_btn').click(function(){
      $('.side_menu_container').toggleClass('active');
      $('.menu_open_bg').toggleClass('active');
    });
    $('.menu_open_bg').click(function(){
      $('.side_menu_container').toggleClass('active');
      $('.menu_open_bg').toggleClass('active');
    });
    $('.side_menu_inner li a').click(function(){
      $('.side_menu_container').toggleClass('active');
      $('.menu_open_bg').toggleClass('active');
    });
    $('ul.side_menu li a').click(function(){
      $('.side_menu_container').removeClass('active');
      $('.menu_open_bg').removeClass('active');
    });
    $('.top_btn a').click(function(){
      $('.side_menu_container').removeClass('active');
      $('.menu_open_bg').removeClass('active');
    });


});
